module.exports = __webpack_public_path__ + "statics/img/cate10-5@2x.59f5ff3b.png";